module.exports = __webpack_public_path__ + "static/media/MovementChange.87d91f35.png";